<template>
  <div class="notice">
    <!-- <bannerof
      style="color: #1d4434"
      :Imgsrc="bannerData.imgUrl"
      :title="bannerData.title"
      :subtitle="bannerData.subtit"
    ></bannerof> -->
    <secondary-banner title="行业动态"></secondary-banner>
    <!-- 政策列表 -->
    <div class="notice_list secondary_page_bg">
      <div class="list_center">
        <div class="list_rights">
          <div class="zhengce">
            <noticelist
              :notLits="notLitsa"
              @setNotice="
                (data) => {
                  getNotice(data);
                }
              "
            ></noticelist>
          </div>
          <div class="page_pl">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pagesize"
              background
              layout="total,prev, pager, next"
              :total="total"
              hide-on-single-page
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import noticelist from "@/components/Noticelist";
import { nocget } from "@/api/notice.js";
import bannerof from "@/components/bannerof";
import SecondaryBanner from "@/components/SecondaryBanner";
export default {
  name: "notice",
  data() {
    return {
      notLitsa: null, //政策列表
      notLitsb: null,
      total: 0,
      pagesize: 6,
      currentPage: 1,
      bannerData: {
        title: "",
        subtit: "",
        imgUrl: require("@/assets/images/zhengce.png"),
      },
    };
  },
  components: {
    noticelist,
    bannerof,
    SecondaryBanner,
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", 1020);
  },
  mounted() {
    this.getnotlistall();
  },
  methods: {
    getnotlistall() {
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
      };
      nocget(params).then((res) => {
        this.notLitsa = res.rows;
        this.total = res.total;
        this.toTop();
      });
    },
    getNotice(data) {
      let title = data.noticeType;
      let id = data.noticeId;

      let rourl = this.$router.resolve({
        name: "NoticeDetails",
        params: { name: "natice-detail", title, id },
      });
      window.open(rourl.href);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      this.getnotlistall(this.active);
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.notice {
  width: 100%;

  //  政策列表
  .notice_list {
    width: 100%;
    padding: 72px 0 100px 0;
    overflow: hidden;

    .list_center {
      width: 1200px;
      padding: 40px 20px 0 20px;
      background-color: #ffffff;
      margin: 0 auto;
      overflow: hidden;

      .list_left {
        float: left;
        .tabs_left {
          padding: 10px 40px;
          font-size: 20px;
          margin-top: 15px;
          background: rgba(238, 238, 238, 0.4);
          color: #555555;
          cursor: pointer;
        }
        .tab_active {
          color: #ffffff;
          background: #1d4434;
        }
      }
      .list_rights {
        width: 100%;
        .page_pl {
          margin: 30px 0;
          text-align: center;
        }
      }
    }
  }
}
</style>
